import { WSQueryConfig } from "@ws-react-query";
import {
  ApiQueryListWorkItems,
  listWorkItems
} from "../../../services/workItem";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";

export const QUERY_WORK_ITEMS = "QUERY_WORK_ITEMS";

export const useQueryWorkItems = (
  query: ApiQueryListWorkItems,
  config?: WSQueryConfig<
    Awaited<ReturnType<typeof listWorkItems>>,
    WSServiceError
  >
) => useWSQuery([QUERY_WORK_ITEMS, query], () => listWorkItems(query), config);
